module.exports = __webpack_public_path__ + "media/splashconcert.2e2cc715.mp4";